module.exports = __webpack_public_path__ + "static/media/content-khai-khoang-1.14871b3b.jpg";